<template>
    <c-dialog ref="dialog" mode="slide" width="50vw" mask-close :button="false">
        <template #head>
            <div class="m-detail-tag flex-center-cross">
                <label v-if="afterSale.after_sale_no">{{afterSale.after_sale_no}}</label>
                <c-state v-if="afterSale.after_sale_no" tag async dict="SALE_AFTER_SALE_STATE" :value="afterSale.after_sale_state"></c-state>
                <span v-if="saasName" class="m-detail-saas">{{saasName}}</span>
            </div>
        </template>

        <div class="m-after-sale-detail">
            <c-title>基础信息</c-title>
            <c-detail class="m-detail-table" column="2">
                <c-detail-item label="所属商户" colspan="2">{{saasName || '-'}}</c-detail-item>
                <c-detail-item label="订单号">{{afterSale.order_no || '-'}}</c-detail-item>
                <c-detail-item label="三方订单号">{{afterSale.third_party_order_no || afterSale.order_no || '-'}}</c-detail-item>
                <c-detail-item label="销售渠道">
                    {{afterSale.channel_name || '-'}}
                </c-detail-item>
                <c-detail-item label="售出价">{{formatPrice(product.sale_price)}}</c-detail-item>
                <c-detail-item label="售后类型">
                    <c-state async dict="SALE_AFTER_SALE_TYPE" :value="afterSale.after_sale_type"></c-state>
                </c-detail-item>
                <c-detail-item label="退款金额">
                    <span class="m-amount">{{formatPrice(afterSale.after_sale_amount)}}</span>
                </c-detail-item>
                <c-detail-item label="退款信息">
                    <span v-if="!Number(afterSale.refund_amount)">-</span>
                    <div v-else class="m-product-info">
                        <p class="m-amount">{{formatPrice(afterSale.refund_amount)}}</p>
                        <p class="m-product-info-code">{{afterSale.refund_date || '-'}}</p>
                    </div>
                </c-detail-item>
                <c-detail-item label="创建时间">{{afterSale.create_date || '-'}}</c-detail-item>
                <c-detail-item label="售后原因" colspan="2">{{afterSale.refund_reason || '-'}}</c-detail-item>
                <c-detail-item label="售后图片" colspan="2">
                    <c-file-list v-if="afterSale.after_image_list" :value="afterSale.after_image_list"></c-file-list>
                    <span v-else>-</span>
                </c-detail-item>
            </c-detail>

            <c-title>产品信息</c-title>
            <h3 class="m-product-title">{{getProductFullName()}}</h3>
            <c-detail class="m-detail-table" column="2">
                <c-detail-item label="分类">{{product.category_name || '-'}}</c-detail-item>
                <c-detail-item label="品牌/型号">{{getBrandModelText()}}</c-detail-item>
                <c-detail-item label="等级">{{product.level_name || '-'}}</c-detail-item>
                <c-detail-item label="背贴码">{{product.produce_code || '-'}}</c-detail-item>
                <c-detail-item label="内存">{{product.memory_name || '-'}}</c-detail-item>
                <c-detail-item label="IMEI">{{product.imei || '-'}}</c-detail-item>
                <c-detail-item label="颜色">{{product.color_name || '-'}}</c-detail-item>
            </c-detail>

            <template v-if="afterSale.order_type == 2 && afterSale.after_sale_type == 1 && afterSale.after_sale_state > 1 && afterSale.after_sale_state < 6">
                <c-title>退货信息</c-title>
                <c-detail class="m-detail-table" column="2">
                    <c-detail-item label="退货地址" colspan="2">{{afterSale.return_full_name || ''}} {{afterSale.return_phone || ''}} {{afterSale.return_address || '-'}}</c-detail-item>
                    <c-detail-item label="退货快递">{{afterSale.return_express_company || '-'}} {{afterSale.return_express_no || '-'}}</c-detail-item>
                    <c-detail-item label="退货时间">{{afterSale.return_express_update_date || '-'}}</c-detail-item>
                    <c-detail-item v-if="afterSale.after_sale_state == 4 || afterSale.after_sale_state == 5" label="确认收货人">{{afterSale.confirm_receive_user_realname || '-'}}</c-detail-item>
                    <c-detail-item v-if="afterSale.after_sale_state == 4 || afterSale.after_sale_state == 5" label="确认收货时间">{{afterSale.confirm_receive_date || '-'}}</c-detail-item>
                </c-detail>
            </template>

            <template v-if="afterSale.after_sale_state == 2 || afterSale.after_sale_state == 5 || afterSale.after_sale_state == 6">
                <c-title>审批信息</c-title>
                <c-detail class="m-detail-table" column="2">
                    <c-detail-item label="审批人">{{afterSale.audit_user_realname || '-'}}</c-detail-item>
                    <c-detail-item label="审批时间">{{afterSale.audit_date || '-'}}</c-detail-item>
                    <c-detail-item v-if="afterSale.after_sale_state == 6" label="驳回原因">{{afterSale.audit_remark || '-'}}</c-detail-item>
                    <c-detail-item v-if="afterSale.after_sale_state == 5" label="退款人">{{afterSale.refund_user_realname || '-'}}</c-detail-item>
                    <c-detail-item v-if="afterSale.after_sale_state == 5" label="退款时间">{{afterSale.refund_date || '-'}}</c-detail-item>
                </c-detail>
            </template>
        </div>
    </c-dialog>
</template>

<script>
export default {
    name: 'erpOnlineAftersaleDetail',

    data() {
        return {
            saasName: '',
            afterSaleId: '',
            productId: '',
            afterSale: {},
            product: {}
        }
    },

    methods: {
        /*********打开抽屉（data=列表行）**********/
        open(data = {}) {
            this.saasName = data.saas_name || '';
            this.afterSaleId = data.after_sale_id;
            this.productId = data.id;
            this.afterSale = {};
            this.product = {};
            this.$refs.dialog.open({title: '线上售后详情'});
            this.request({
                url: '/aftersale/ops/product_detail',
                data: {
                    merchant_id: data.saas_id,
                    id: this.afterSaleId,
                    after_sale_product_id: this.productId
                },
                loading: true,
                success: data => {
                    this.afterSale = data.order_info || {};
                    this.product = data.product_info || {};
                }
            });
        },

        /*********格式化价格**********/
        formatPrice(price) {
            if (price === null || price === undefined || price === '') return '-';
            return '¥' + parseFloat(price).toFixed(2);
        },

        /*********获取完整产品名称**********/
        getProductFullName() {
            var p = this.product;
            var parts = [];
            if (p.brand_name) parts.push(p.brand_name);
            if (p.model_name) parts.push(p.model_name);
            if (p.color_name) parts.push(p.color_name);
            if (p.memory_name) parts.push(p.memory_name);
            return parts.join(' ') || this.afterSale.product_name || '-';
        },

        /*********获取品牌/型号文本**********/
        getBrandModelText() {
            var p = this.product;
            var parts = [];
            if (p.brand_name) parts.push(p.brand_name);
            if (p.model_name) parts.push(p.model_name);
            return parts.join(' / ') || '-';
        }
    }
}
</script>

<style scoped>
.m-after-sale-detail {
    padding: 0 20px 20px;
}

.m-product-title {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    margin: 0 0 20px 0;
    color: #333;
}

.m-detail-table ::v-deep .c-detail-item-label {
    background-color: #fafafa;
    color: #666;
    text-align: right;
}

.m-detail-table .m-amount {
    color: #e53e3e;
    font-weight: bold;
}

.m-detail-tag {
    gap: 8px;
    font-size: 14px;
    font-weight: bold;
}

.m-detail-saas {
    font-size: 12px;
    font-weight: normal;
    color: #999;
}

.m-product-info {
    line-height: 24px;
    font-size: 13px;
    color: #333;
}

.m-product-info p {
    margin: 0;
}
</style>
